// import { useState, useEffect } from "react";
// import { Pagination } from "react-bootstrap";
// import { useCollection } from "react-firebase-hooks/firestore";
// import { usersQuery } from "../utils/queryHelpers";
// import { Loader } from "../hooks/useLoading";

const SearchUsers = ({
  setUserList,
  userListSet,
  setUserListSet,
  userSnapshot,
  userError,
}) => {
  return (
    <div>
      <div
        className="list-group"
        style={{
          height: "calc(100vh - 200px)",
          overflowY: "auto",
        }}
      >
        {userError ? (
          <p className="text-error">
            There is some error. Please try again later
          </p>
        ) : null}
        {userSnapshot?.length < 1 ? (
          <p className="text-center flex-fill"> No Data Available</p>
        ) : null}
        {userSnapshot?.map((d) => {
          // const d = { ...data.data(), id: data.id };
          // console.log("user dta : ", d);
          return (
            <div
              className="d-flex justify-content-between list-group-item "
              key={d.id}
            >
              {d.first_name + " " + d.last_name}
              {userListSet.has(d.id) ? (
                <button
                  className={`btn btn-danger`}
                  onClick={() => {
                    setUserList((prev) => prev.filter((x) => x.id !== d.id));
                    setUserListSet((prev) => {
                      prev.delete(d.id);
                      return new Set([...prev]);
                    });
                  }}
                >
                  Remove
                </button>
              ) : (
                <button
                  className={`btn btn-primary`}
                  onClick={() => {
                    if (userListSet.has(d.id)) return;
                    setUserList((prev) => [...prev, d]);
                    setUserListSet((prev) => {
                      return new Set([...prev, d.id]);
                    });
                  }}
                >
                  Add
                </button>
              )}
            </div>
          );
        })}
      </div>
      {/* <Pagination>
        <Pagination.First />
        <Pagination.Prev />
        <Pagination.Item>{1}</Pagination.Item>
        <Pagination.Ellipsis />

        <Pagination.Item>{10}</Pagination.Item>
        <Pagination.Item>{11}</Pagination.Item>
        <Pagination.Item active>{12}</Pagination.Item>
        <Pagination.Item>{13}</Pagination.Item>
        <Pagination.Item disabled>{14}</Pagination.Item>

        <Pagination.Ellipsis />
        <Pagination.Item>{20}</Pagination.Item>
        <Pagination.Next />
        <Pagination.Last />
      </Pagination> */}
    </div>
  );
};

export default SearchUsers;
